<template>
    <div class="page-content page-content-full">
        <h1>Page Not Found</h1>
        <p>Sorry, this page can't be found.</p>
    </div>
</template>
<script>
    export default {
        name: 'PageNotFoundView'
    }
</script>
